export default __webpack_public_path__ + "static/media/KOD0091-min.bdee62c1.webp";